import { BdArrayUtil } from '@bindoc-projects/util-domain-lib';
import type {
  FilterConditionPluginSpecification,
} from '../filter.plugin';
import {
  FilterConditionPluginImpl
} from '../filter.plugin';
import type {
  BdCondition,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdContentCondition,
} from '@bindoc-projects/condition-domain-lib';
import type { AtVirtualClinicTissAAtmungsmodus } from '@bindoc-projects/virtual-clinic-domain-lib';

export const AT_TISS_A_ATMUNGSMODUS_CONDITION_ID = 'tissAAtmungsmodus';
export const AtFilterConditionTissAAtmungsmodusPluginType: FilterConditionPluginSpecification<
  AtVirtualClinicTissAAtmungsmodus[],
  AtFilterConditionTissAAtmungsmodusDto,
  AtTissAAtmungsmodusCondition
> = {
  type: 'tissAAtmungsmodus',
  category: 'case',
  displayName: { de: 'TISS-A: Atmungsmodus' },
  sortingIndex: 22,
  occurrence: 'single',
  fromObject(
    obj: AtFilterConditionTissAAtmungsmodusDto,
  ): FilterConditionPluginImpl<AtVirtualClinicTissAAtmungsmodus[]> {
    return new AtFilterConditionTissAAtmungsmodusPlugin(obj.tissAAtmungsmodus);
  },
  fromCondition(
    jsonObj: AtTissAAtmungsmodusCondition,
  ): FilterConditionPluginImpl<AtVirtualClinicTissAAtmungsmodus[]> {
    return new AtFilterConditionTissAAtmungsmodusPlugin(jsonObj.includes ?? []);
  },
  newInstance(): FilterConditionPluginImpl<AtVirtualClinicTissAAtmungsmodus[]> {
    return new AtFilterConditionTissAAtmungsmodusPlugin([]);
  },
};

export class AtFilterConditionTissAAtmungsmodusPlugin extends FilterConditionPluginImpl<
  AtVirtualClinicTissAAtmungsmodus[],
  AtFilterConditionTissAAtmungsmodusDto
> {
  static override Specification: FilterConditionPluginSpecification<
    AtVirtualClinicTissAAtmungsmodus[],
    AtFilterConditionTissAAtmungsmodusDto,
    AtTissAAtmungsmodusCondition
  > = AtFilterConditionTissAAtmungsmodusPluginType;

  constructor(
    protected tissAAtmungsmodus: AtVirtualClinicTissAAtmungsmodus[],
  ) {
    super(AtFilterConditionTissAAtmungsmodusPluginType.type);
  }

  clone(): AtFilterConditionTissAAtmungsmodusPlugin {
    return new AtFilterConditionTissAAtmungsmodusPlugin([
      ...this.tissAAtmungsmodus,
    ]);
  }

  override equals(other: AtFilterConditionTissAAtmungsmodusPlugin): boolean {
    return (
      super.equals(other) &&
      BdArrayUtil.equals(this.tissAAtmungsmodus, other.tissAAtmungsmodus)
    );
  }

  override validationToText(): string {
    if (this.tissAAtmungsmodus.length === 0) {
      return 'Mindestens einen Atmungsmodus auswählen';
    } else {
      return '';
    }
  }

  toCondition(): BdCondition | null {
    return new AtTissAAtmungsmodusCondition(this.tissAAtmungsmodus, []);
  }

  toText(): string | null {
    return this.tissAAtmungsmodus.length === 1
      ? 'ein Atmungsmodus'
      : `${this.tissAAtmungsmodus.length} Atmungsmodi`;
  }

  toJSON(): AtFilterConditionTissAAtmungsmodusDto | null {
    return {
      type: this.type,
      tissAAtmungsmodus: this.tissAAtmungsmodus,
    };
  }

  toValue(): AtVirtualClinicTissAAtmungsmodus[] {
    return this.tissAAtmungsmodus;
  }
}

export class AtTissAAtmungsmodusCondition extends BdContentCondition<AtVirtualClinicTissAAtmungsmodus> {
  constructor(
    includes: AtVirtualClinicTissAAtmungsmodus[],
    excludes: AtVirtualClinicTissAAtmungsmodus[],
  ) {
    super(AT_TISS_A_ATMUNGSMODUS_CONDITION_ID, includes, excludes);
  }
}

interface AtFilterConditionTissAAtmungsmodusDto {
  type: string;
  tissAAtmungsmodus: AtVirtualClinicTissAAtmungsmodus[];
}
